/** 来源：crm/foodbuy/market Input；收敛为原生属性透传并支持 ref。 */
import { forwardRef, type InputHTMLAttributes } from 'react'
import { controlClassName } from './control-classes'

export type InputProps = InputHTMLAttributes<HTMLInputElement> & { error?: boolean }

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className = '', error = false, ...props },
  ref
) {
  return <input ref={ref} className={controlClassName(className, error)} aria-invalid={error || undefined} {...props} />
})
